// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleHeadline_root__2X2GJ","articleSummary":"ArticleHeadline_articleSummary__20DdZ","selectionCheckbox":"ArticleHeadline_selectionCheckbox__Bzyrq"};